import { openBrowserAsync } from "expo-web-browser";
import { Platform } from "react-native";

export function openNewTab(url: string) {
  if (Platform.OS === "web") open(url, "_blank");
  // eslint-disable-next-line typescript-eslint/no-floating-promises
  else openBrowserAsync(url);
}
